'use client';

import React from 'react';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { handleUseStrapiImageUrl } from 'helpers/strapi';

import { styles } from '.';

type TProps = {
  cta_section: any;
  locale: string;
};

const CTASection = (props: TProps) => {
  const { cta_section, locale } = props;

  const pathname = usePathname();

  if (pathname.includes('/jobs') || pathname.includes('/join-the-family')) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Image
        src={handleUseStrapiImageUrl(cta_section?.backgroundImage?.url)}
        alt={
          cta_section?.backgroundImage?.alternativeText ?? 'background-image'
        }
        fill
        className={styles.image}
      />
      <div className={styles.content}>
        <h3 className={styles.title}>{cta_section?.title}</h3>
        <Link
          href={`/${locale}${cta_section?.action?.url}`}
          className={styles.link}
        >
          {cta_section?.action?.label}
        </Link>
      </div>
    </div>
  );
};

export default CTASection;
